// extracted by mini-css-extract-plugin
export default {"menuBtn":"Options_menuBtn__aW1Ja"};